module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/is-1842f1a952e8f0d4ca471d3cd3872b2a.svg";